import PageContainer from "@components/layout/PageContainer";
import ProductsByCategoryForm from "@components/dynamic/ProductsByCategoryForm";

const ProductsByCategoryReport = () => {
  return (
    <PageContainer
      title="Reporte por Categoria"
      backUrl="/user/dashboard-inventory"
    >
      <ProductsByCategoryForm />
    </PageContainer >
  );
}

export default ProductsByCategoryReport;
